/**
 * PB Unified Top Bar — language selector.
 *
 * The selector is a <details> holding host-relative links (/fr/…), so opening,
 * closing and switching language all work without JS — and the visitor stays on
 * the brand subdomain they came from. This only adds what browsers do not give
 * us for free: closing on an outside click, closing on Escape, and carrying the
 * current query string over to the other language.
 */
(() => {
  const SELECTOR = '[data-pb-unified-top-bar-language]';
  const LINK = '[data-pb-unified-top-bar-language-link]';

  /** @param {Element | null} except - Stays open, everything else closes. */
  const closeAll = (except) => {
    document.querySelectorAll(`${SELECTOR}[open]`).forEach((details) => {
      if (details !== except) details.open = false;
    });
  };

  /**
   * Appends the current query string and hash to each language link, so
   * filters, ?variant= and the like survive a language switch. Runs every time
   * the panel opens, because the theme rewrites the URL client-side (collection
   * filters) after page load.
   *
   * @param {Element} details - The open selector.
   */
  const syncLinks = (details) => {
    const suffix = window.location.search + window.location.hash;

    details.querySelectorAll(LINK).forEach((link) => {
      if (!(link instanceof HTMLAnchorElement)) return;
      if (!link.dataset.pbBaseHref) link.dataset.pbBaseHref = link.getAttribute('href') ?? '';
      link.setAttribute('href', link.dataset.pbBaseHref + suffix);
    });
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    closeAll(target ? target.closest(SELECTOR) : null);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const open = document.querySelector(`${SELECTOR}[open]`);
    if (!open) return;

    open.open = false;
    const summary = open.querySelector('summary');
    if (summary instanceof HTMLElement) summary.focus();
  });

  // `toggle` does not bubble, so listen in the capture phase.
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (details instanceof HTMLDetailsElement && details.matches(SELECTOR) && details.open) {
        syncLinks(details);
      }
    },
    true
  );
})();
